import { createFileRoute, redirect } from '@tanstack/react-router'

import { AnalyticsPage } from '@/pages/analytics/Analytics.page'
import { getIsAnalyticsDashboardEnabled } from '@/stores/features.store'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/analytics',
)({
  component: AnalyticsPage,
  beforeLoad: () => {
    if (!getIsAnalyticsDashboardEnabled()) {
      throw redirect({
        to: '/',
      })
    }
  },
  loader: () => ({ breadcrumbTitle: 'Analytics' }),
})
